// extracted by mini-css-extract-plugin
export default {"section":"EGMC0z9OhXNk7R4RaD4Y","horizontalContent":"lYJSmhQtjrrfVMY0y9oB","verticalContent":"r5PaIVx4_rC7VpATLaC9"};